// extracted by mini-css-extract-plugin
export default {"welcome":"styles-module__jt1FJ","welcomeHeader":"styles-module__pPw5R"};